<div fxFlex="0 0 100%" fxLayout="column">
    <div class="explain-bar" fxFlex="0 0 5%" fxLayout="row" >
        <span class="explain-currency" fxFlex="1 0 auto" fxFlexAlign="left">Currency: {{explainedCurrency | uppercase}}</span>
        <span class="explain-date" fxFlex="1 0 auto" fxFlexAlign="left">Date: {{explainedDate }}</span>
        <span *ngIf="!panelBlocked" fxFlex="5 5 grow" fxFlexAlign="center"></span>
        <p-progressBar *ngIf="panelBlocked" mode="indeterminate" [style]="{'height': '6px'}" fxFlex="5 5 grow" fxFlexAlign="center"></p-progressBar>
        <span class="explain-time" fxFlex="1 0 auto" fxFlexAlign="right">{{explainedRequestTime}}</span>
    </div>
    <div #explainPanel [style]="{'padding':'0px', 'border':'0', 'height': '100%'}">
        <div class="compare-explain-main" fxLayout="column">
            <div fxFlex="0 0 15%" class="liquidity-mode-toggle">
                <mat-button-toggle-group (change)="onLiquidityModeChange($event)">
                    <mat-button-toggle value="gross" [checked]="liquidityMode === 'gross'">
                        <span>Gross</span>
                    </mat-button-toggle>
                    <mat-button-toggle value="net" [checked]="liquidityMode === 'net'">
                        <span>Net</span>
                    </mat-button-toggle>
                    <mat-button-toggle value="in" [checked]="liquidityMode === 'in'">
                        <span>In</span>
                    </mat-button-toggle>
                    <mat-button-toggle value="out" [checked]="liquidityMode === 'out'">
                        <span>Out</span>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <div class="chartwrapper" fxFlex="0 0 30vh">
                <div id="comparechartdiv" class="chartdiv"></div>
            </div>
            <app-explain-tables fxFlex="0 0 50%"></app-explain-tables>
        </div>
    </div>
    <!-- <p-blockUI [target]="explainPanel" [blocked]="panelBlocked">
        <i class="fa fa-spin fa-circle-o-notch fa-5x" style="position:absolute;top:25%;left:50%"></i>
    </p-blockUI> -->
</div>